import React, { useEffect } from 'react';

import { Autocomplete, TextField } from '@mui/material';

import Styles from '../lib/Styles';
import IState from '../shared/IState.js';
import classes from './SelectBoxedField.module.scss';
import states from './USStates.json';

export default function SelectUSState(props: any) {
  const { selectedUSState, setSelectedUSState, onChangeUSState, readOnly = false, required = false } = props;
  let initialValue = React.useRef(props.initialValue);
  const cx = new Styles(classes).cx;

  useEffect(() => {
    if (initialValue.current) {
      const indexState = states.findIndex((state) => state.abbreviation === initialValue.current);
      if (indexState >=0) {
        const state = states[indexState];
        setSelectedUSState(state);
      }
      initialValue.current = undefined;
    }
  }, [setSelectedUSState])

  function onChangeSelectedUSState(event: any, value: any) {
    setSelectedUSState(value);
    onChangeUSState();
  }

  return (
    <div className={cx('root')}>
      <Autocomplete
        disabled={readOnly || (!states || states.length === 0)}
        options={states}
        getOptionLabel={(option: IState) => (option && option.name) ? option.name : ''}
        value={selectedUSState || null}
        filterSelectedOptions
        onChange={onChangeSelectedUSState}
        renderInput={(params: any) => (
          <TextField
            {...params}
            name={'ignore-shift-key-pub-sub'}
            variant="outlined"
            label="State"
            fullWidth
            required={required}
            placeholder={"Select State"}
          />
        )}
      />
    </div>
  );
}
